export default {
  selectAddress: {
    query: {}
  },
  addressList: {},
  googleMapScript: undefined,
  currencyCityObj: {
    code: '855120000',
    parent: '', // 父级的code
    message: {
      "en-US" : "Phnom penh",
      "zh-CN" : "金边市",
      "km-KH" : "ទីក្រុងភ្នំពេញ"
    },
    longitude: 104.909059,
    latitude: 11.568231,
    // level 11 = 省/市  level 12 = 区
    zlevel: 11
  },
  // 当前定位城市
  currentCity: {
    code: '',
    message: {
      "en-US" : "Positioning",
      "zh-CN" : "定位中",
      "km-KH" : "ទីតាំង"
    }, // msg应该是根据当前语言显示的
    longitude: null,
    latitude: null,
  },
}